exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card{background-color:#fff;cursor:move;margin:.5rem;padding:.5rem 1rem}.container{border:1px solid gray;height:404px;overflow:scroll}.container-active{background-color:#90ee90}.container-inactive{background-color:#fff}.drag-and-drop{display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;padding-top:20px}.dragging{opacity:0}.stationary{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/drag-and-drop/index.scss
// module id = 5246
// module chunks = 0